import { render } from "./openorders.vue?vue&type=template&id=c3e71efe"
import script from "./openorders.vue?vue&type=script&lang=js"
export * from "./openorders.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/holcimsgeportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__